import { tabsHandler } from './tabs';
import { dropdownHandler } from './dropdown';
import { inputHandler } from './input';

const onFilter = async(body, list, searchResultHtml, page) => {
  const searchResults = document.getElementById('search-results');

  const apiUrl = searchResults.getAttribute('data-api-url');
  const numberOfItemsPerPage = searchResults.getAttribute('data-number-of-items-per-page');

  const params = new URLSearchParams({
    query: body.search,
    numberOfItemsPerPage: numberOfItemsPerPage,
    page: page,
    category: body.tabMenu,
  });

  const fetchUrl = apiUrl + '?' + params.toString();

  try {
    const res = await fetch(fetchUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const htmlResponse = await res.text();

    if (htmlResponse) {
      const searchResultsMessage = htmlResponse.substring(0, htmlResponse.indexOf('<ul>'));

      if (searchResultsMessage) searchResultHtml.innerHTML = searchResultsMessage;

      list.innerHTML = htmlResponse.substring(htmlResponse.indexOf('<ul>'));
    }

  } catch (error) {
    const errorHtml = await error.text();

    if (errorHtml) list.innerHTML = errorHtml;
  }
};

const onLoadMore = (el, body, searchResultsList, searchResult) => {

  if (el.tagName === 'BUTTON' && el.hasAttribute('data-load-more')) {
    const nextPage = el.getAttribute('data-next-page');
    onFilter(body, searchResultsList, searchResult, nextPage);
    return;
  }
};

const onSearchResultsLoad = () => {
  const searchResults = document.getElementById('search-results');

  if (!searchResults) return;

  const searchResult = searchResults.querySelector('[data-search-result]');
  const dropdown = searchResults.querySelector('[data-dropdown]');
  const searchResultsList = searchResults.querySelector('#search-results-list');
  const input = searchResults.querySelector('[data-input-field]');
  const tabs = searchResults.querySelector('[data-tabs]');

  const body = {};

  dropdownHandler(dropdown, (value) => {
    body.tabMenu = value;
    if (Object.keys(body).length === 2) onFilter(body, searchResultsList, searchResult, 1);

  });
  tabsHandler(tabs, searchResultsList, (value) => {
    body.tabMenu = value;
    if (Object.keys(body).length === 2) onFilter(body, searchResultsList, searchResult, 1);
  });
    inputHandler(input, (value) => {
    const trimmedValue = value.trim();
        body.search = trimmedValue;
    body.tabMenu = '';
      if (trimmedValue && Object.keys(body).length === 2) onFilter(body, searchResultsList, searchResult, 1);
  });

  searchResultsList?.addEventListener('click', (e) => onLoadMore(e.target, body, searchResultsList, searchResult));

};

export default onSearchResultsLoad;
